import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFileBend: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconFileBend"><Path d="M4 4.5C4 3.11929 5.11929 2 6.5 2H12.5V7C12.5 8.38071 13.6193 9.5 15 9.5H20V19.5C20 20.8807 18.8807 22 17.5 22H6.5C5.11929 22 4 20.8807 4 19.5V4.5Z" fill="currentColor"/><Path d="M19.6892 8.50001C19.6498 8.44873 19.6069 8.39979 19.5607 8.35356L13.6464 2.43935C13.6002 2.39311 13.5513 2.35021 13.5 2.31079V7.00001C13.5 7.82843 14.1716 8.50001 15 8.50001H19.6892Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFileBend;
